/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { getColorRamp } from '../../utils/UNSAFE_visUtils';
import { BarItemData, BarSeriesData } from '../../UNSAFE_BarChart/barChart.types';
import { LineAreaItem, LineAreaSeriesData } from '../../UNSAFE_LineAreaChart/lineAreaChart.types';
import { getMarkers } from './utils';

export function getItemColor<K, D>(
  seriesIndex: number,
  groupIndex: number,
  series: (LineAreaSeriesData<K, D> | BarSeriesData<K, D>)[],
  getDataItem: (
    seriesIndex: number,
    groupIndex: number
  ) => LineAreaItem<K> | BarItemData<K> | undefined
) {
  const item = getDataItem(seriesIndex, groupIndex);
  if (item?.color) {
    return item.color;
  }

  if ((item as LineAreaItem<K>).markerColor) {
    return (item as LineAreaItem<K>).markerColor;
  }
  const itemSeries = series[seriesIndex] as LineAreaSeriesData<K, D>;

  const colors = getColorRamp();
  return (
    itemSeries.color ||
    itemSeries.lineColor ||
    itemSeries.areaColor ||
    colors[seriesIndex % colors.length]
  );
}

export function getMarkerType<K>(
  seriesIndex: number,
  groupIndex: number,
  chartType: 'bar' | 'lineWithArea',
  getDataItem: (
    seriesIndex: number,
    groupIndex: number
  ) => LineAreaItem<K> | BarItemData<K> | undefined
) {
  if (chartType === 'bar') {
    return 'circle';
  }
  const item = getDataItem(seriesIndex, groupIndex);
  if ((item as LineAreaItem<K>).markerType) {
    return (item as LineAreaItem<K>).markerType;
  }
  const shapes = getMarkers();
  return shapes[seriesIndex % shapes.length];
}
